<template>
	<v-card class="elevation-0">
		<v-card-text style="padding-bottom: 0; border: 1px solid #185EA91A; background-color: #E7EEF6;">
			<v-container class="px-2 pt-1 pb-2">
				<v-row class="mt-1 mb-6 px-1 d-flex justify-space-between align-center">
					<v-col cols="12" class="py-0 px-2 d-flex justify-space-between align-center">
						<span style="font-size: 20px;" class="black--text">{{ selectedPlan }}</span>
						<span style="font-size: 20px;" class="black--text">{{ renewalDate }}</span>
					</v-col>
				</v-row>
				<div v-if="itemType === constants.ITEM_EMPLOYEES">
					<v-row class="py-4 d-flex justify-space-between align-center" style="border-bottom: 1px solid #185EA91A;">
						<v-col cols="6" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ $t('wkt.admin.license.purchase-license-item-window.employees.current') }}
							</span>					
						</v-col>
						<v-col cols="2" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ currentEmployees }}
							</span>
						</v-col>
					</v-row>
					<v-row class="py-4 d-flex justify-space-between align-center" style="border-bottom: 1px solid #185EA91A;">
						<v-col cols="6" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ $t('wkt.admin.license.purchase-license-item-window.employees.additional') }}
							</span>
							<span style="font-size: 14px;" class="d-block">
								{{ employeePricePerMonth }}
							</span>						
						</v-col>
						<v-col cols="2">
							<v-text-field 
							hide-details
							v-model="additionalEmployees" 
							@keydown.prevent
							@input="$emit('employees-changed', parseInt($event))"
							class="ma-0 pa-0"
							type="number" 
							step="1"
							:min="1" />
						</v-col>
					</v-row>
					<v-row class="py-4 d-flex justify-space-between align-center" style="border-bottom: 1px solid #185EA91A;">
						<v-col cols="6" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ $t('wkt.admin.license.purchase-license-item-window.employees.total') }}
							</span>					
						</v-col>
						<v-col cols="2" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ totalEmployees }}
							</span>
						</v-col>
					</v-row>
				</div>
				<div v-if="itemType === constants.ITEM_STORAGE">
					<v-row class="py-4 d-flex justify-space-between align-center" style="border-bottom: 1px solid #185EA91A;">
						<v-col cols="6" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ $t('wkt.admin.license.purchase-license-item-window.storage.current') }}
							</span>					
						</v-col>
						<v-col cols="2" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ currentStorage }}
							</span>
						</v-col>
					</v-row>
					<v-row class="py-4 d-flex justify-space-between align-center" style="border-bottom: 1px solid #185EA91A;">
						<v-col cols="6" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ $t('wkt.admin.license.purchase-license-item-window.storage.additional') }}
							</span>
							<span style="font-size: 14px;" class="d-block">
								{{ storagePricePerMonth }}
							</span>						
						</v-col>
						<v-col cols="2">
							<v-text-field 
							hide-details
							v-model="additionalStorage" 
							@keydown.prevent
							@input="$emit('storage-changed', parseInt($event))"
							class="ma-0 pa-0"
							type="number" 
							step="1"
							:min="1" />
						</v-col>
					</v-row>
					<v-row class="py-4 d-flex justify-space-between align-center" style="border-bottom: 1px solid #185EA91A;">
						<v-col cols="6" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ $t('wkt.admin.license.purchase-license-item-window.storage.total') }}
							</span>					
						</v-col>
						<v-col cols="2" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ totalStorage }}
							</span>
						</v-col>
					</v-row>
				</div>
				<div v-if="itemType === constants.ITEM_SIGNATURES">
					<v-row class="py-4 d-flex justify-space-between align-center" style="border-bottom: 1px solid #185EA91A;">
						<v-col cols="6" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ $t('wkt.admin.license.purchase-license-item-window.signatures.current') }}
							</span>					
						</v-col>
						<v-col cols="2" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ currentSignatures }}
							</span>
						</v-col>
					</v-row>
					<v-row class="py-4 d-flex justify-space-between align-center" style="border-bottom: 1px solid #185EA91A;">
						<v-col cols="6" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ $t('wkt.admin.license.purchase-license-item-window.signatures.additional') }}
							</span>
							<span style="font-size: 14px;" class="d-block">
								{{ signaturePricePerUnit }}
							</span>						
						</v-col>
						<v-col cols="2">
							<v-text-field 
							hide-details
							v-model="additionalSignatures"
							@keydown.prevent
							@input="$emit('signatures-changed', parseInt($event))"
							class="ma-0 pa-0"
							type="number" 
							step="1"
							:min="1" />
						</v-col>
					</v-row>
					<v-row class="py-4 d-flex justify-space-between align-center" style="border-bottom: 1px solid #185EA91A;">
						<v-col cols="6" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ $t('wkt.admin.license.purchase-license-item-window.signatures.total') }}
							</span>					
						</v-col>
						<v-col cols="2" class="py-0">
							<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
								{{ totalSignatures }}
							</span>
						</v-col>
					</v-row>
				</div>
				<v-row class="mt-3 pt-0 pb-2">
					<v-col class="mt-4 pa-0">
						<AddVoucher @voucher-used="$emit('add-voucher', $event)" />
					</v-col>
				</v-row>
			</v-container>
		</v-card-text>
	</v-card>
</template>

<script>
import BaseModule from '../../../common/BaseModule.js';
import PurchaseUtils from './PurchaseUtils.js';
import AddVoucher from './AddVoucher';

export default {
    name: 'PurchaseLicenseItem',
    mixins: [BaseModule, PurchaseUtils],
	props: ['company','licensingInfo','licenseType','licensePlan','currentEmployees','currentStorage','currentSignatures','voucher','itemType'],
	/*watch: {
		currentEmployees: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				this.additionalEmployees = newValue;
			}
		},		
		currentStorage: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				this.additionalStorage = newValue;
			}
		},
		currentSignatures: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				this.additionalSignatures = newValue;
			}
		}
	},*/
	components: {
		AddVoucher
	},
    data () {
		return {
			additionalEmployees: 0,
			additionalStorage: 0, 
			additionalSignatures: 0,
		}
    },
	mounted() {
		console.log(`*** PurchaseLicenseItem.itemType: ${this.itemType}`);

		if (this.itemType === this.constants.ITEM_EMPLOYEES) {
			this.additionalEmployees = 1;
			this.$emit('employees-changed', this.additionalEmployees);
		}
		
		if (this.itemType === this.constants.ITEM_STORAGE) {
			this.additionalStorage = 1;
			this.$emit('storage-changed', this.additionalStorage);
		}		
		
		if (this.itemType === this.constants.ITEM_SIGNATURES) {
			this.additionalSignatures = 5;
			this.$emit('signatures-changed', this.additionalSignatures);
		}
	},
	computed: {
		selectedPlan() {
			if (!this.company) {
				return '???';
			}

			let text = '';

			switch (this.company.licenseType) {
				case 0: 
					text = this.$t('wkt.admin.license.type-free-description');
					break;
				case 1: 
					text = this.$t('wkt.admin.license.type-business-description');
					break;
				case 2: 
					text = this.$t('wkt.admin.license.type-corporate-description');
					break;
			}

			text += ' - ';

			switch (this.company.licensePlan) {
				case 0: 
					text += this.$t('wkt.admin.license.plan-free-description');
					break;
				case 1: 
					text += this.$t('wkt.admin.license.plan-monthly-description');
					break;
				case 2: 
					text += this.$t('wkt.admin.license.plan-annual-description');
					break;
			}

			return text;
		},
		renewalDate() {
			if (!this.company && !this.renewDate) {
				return '???';
			}
			
			let date;

			//if (this.renewDate) {
			//	date = this.renewDate;
			//} else {
				date = this.company.licensePlanExpires;
			//}

			let text = this.formatOnlyDate(date);
			
			text += ' - ';

			let auto;

			//if (this.renewDate) {
			//	auto = this.autorenew;
			//} else {
				auto = this.company.licensePlanAutonrenew;
			//}

			if (auto) {
				text += this.$t('wkt.admin.license.plan.renew.automatic');
			} else {
				text += this.$t('wkt.admin.license.plan.renew.manual');
			}

			return text;
		},
		employeePricePerMonth() {
			if (this.licensingInfo === null || this.licenseType === null || this.licensePlan === null) {
				return '???';
			}

			const license = this.findLicenseSKU(this.licensingInfo, this.constants.ACTIVE_EMPLOYEES, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_EXTENSION);
			
			if (!license) {
				return '';
			}

			let description = 'wkt.admin.license-SKU.additional-employee';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_FREE:
					description += '.free';
					break;
				case this.constants.LICENSE_TYPE_BUSINESS:
					description += '.business';
					break;
				case this.constants.LICENSE_TYPE_CORPORATE:
					description += '.corporate';
					break;
			}

			switch (this.licensePlan) {
				case this.constants.LICENSE_PLAN_MONTHLY:
					description += '.monthly';
					break;
				case this.constants.LICENSE_PLAN_ANNUAL:
					description += '.annual';
					break;
			}
			
			return this.$t(description);

			//return license.description;
				
			/*let text = license.price.toFixed(2);
			text += this.$t('wkt.admin.license.upgrade-account-window.step-2.license-items.employee_price_per_month');

			return text;*/
		},
		/*storageQuantityPerPlan() {
			if (this.licensingInfo === null || this.licenseType === null || this.licensePlan === null) {
				return '???';
			}

			let license = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_EXTENSION);
			
			if (!license) {
				return '???';
			}

			return license.description;
				
			let text = license.quantity;
			text += this.$t('wkt.admin.license.upgrade-account-window.step-2.license-items.storage_quantity_per_plan');

			//license = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_EXTENSION);
			
			//if (!license) {
			//	return text;
			//}
				
			text += ' / ';
			text += license.price.toFixed(2);
			text += this.$t('wkt.admin.license.upgrade-account-window.step-2.license-items.storage_price_per_plan');

			return text;
		},*/
		storagePricePerMonth() {
			if (this.licensingInfo === null || this.licenseType === null || this.licensePlan === null) {
				return '???';
			}

			//const licenseClass = this.licenseType === this.constants.LICENSE_TYPE_FREE ? this.constants.LICENSE_CLASS_BASE : this.constants.LICENSE_CLASS_EXTENSION;

			//const license = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, this.licenseType, this.licensePlan, licenseClass);
			
			const license = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_EXTENSION);

			if (!license) {
				return '';
			}

			let description = 'wkt.admin.license-SKU.additional-storage';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_FREE:
					description += '.free';
					break;
				case this.constants.LICENSE_TYPE_BUSINESS:
					description += '.business';
					break;
				case this.constants.LICENSE_TYPE_CORPORATE:
					description += '.corporate';
					break;
			}

			switch (this.licensePlan) {
				case this.constants.LICENSE_PLAN_MONTHLY:
					description += '.monthly';
					break;
				case this.constants.LICENSE_PLAN_ANNUAL:
					description += '.annual';
					break;
			}
			
			return this.$t(description);

			//return license.description;
				
			/*let text = license.quantity;
			text += this.$t('wkt.admin.license.upgrade-account-window.step-2.license-items.storage_quantity_additional');

			return text;*/
		},
		signaturePricePerUnit() {
			if (this.licensingInfo === null || this.licenseType === null || this.licensePlan === null) {
				return '???';
			}
			
			const stock = this.findStockSKU(this.licensingInfo, this.constants.SMS_SIGNATURE, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_EXTENSION);
			
			if (!stock) {
				return '';
			}

			let description = 'wkt.admin.stock-SKU.additional-signature';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_FREE:
					description += '.free';
					break;
				case this.constants.LICENSE_TYPE_BUSINESS:
					description += '.business';
					break;
				case this.constants.LICENSE_TYPE_CORPORATE:
					description += '.corporate';
					break;
			}

			switch (this.licensePlan) {
				case this.constants.LICENSE_PLAN_MONTHLY:
					description += '.monthly';
					break;
				case this.constants.LICENSE_PLAN_ANNUAL:
					description += '.annual';
					break;
			}
			
			return this.$t(description);

			//return stock.description;
				
			/*let text = stock.price.toFixed(2);
			text += this.$t('wkt.admin.license.upgrade-account-window.step-2.license-items.signature_price_per_unit');

			return text;*/
		},
		totalEmployees() {
			return this.currentEmployees + parseInt(this.additionalEmployees); 
		},
		totalStorage() {
			return this.currentStorage + parseInt(this.additionalStorage);
		},
		totalSignatures() {
			return this.currentSignatures + parseInt(this.additionalSignatures); 
		}
	},
    methods: {
    },
}
</script>